// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderAssignInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/work_order_assign/{work_order_id}
 *
 * Assign a worker to a work order.
 */
import { registerContract } from './validate'

export interface Orders_WorkOrderAssignInput {
user_id: string
}

registerContract('Orders_WorkOrderAssignInput', {
  user_id: { type: 'string',  required: true },
})
